<script>
import Filtro from "./Panel";
import { mapGetters } from "vuex";
import Placeholder from "../Placeholder/Filtros/Admin";
export default {
  components: { Placeholder, Filtro },
  computed: {
    ...mapGetters(["isMaster"])
  },
  data() {
    return {
      deshabilitados: false,
      filtrar_destacados: false,
      filtrar_deshabilitados: false
    };
  },
  watch: {
    deshabilitados(payload) {
      this.filtrar_deshabilitados = false;
      this.$store.commit("setShowDeshabilitados", payload);
    },
    filtrar_destacados(payload) {
      this.$store.commit("setFiltroDestacados", payload);
    },
    filtrar_deshabilitados(payload) {
      this.$store.commit("setFiltroDeshabilitados", payload);
    }
  },
  methods: {
    clear() {
      if (this.deshabilitados) {
        this.deshabilitados = false;
      }

      if (this.filtrar_destacados) {
        this.filtrar_destacados = false;
      }

      if (this.filtrar_deshabilitados) {
        this.filtrar_deshabilitados = false;
      }
    }
  }
};
</script>

<template>
  <div>
    <filtro v-if="isMaster" heading="Admin" icono="tune" :total="false">
      <div class="list-group">
        <label class="list-group-item">
          <input type="checkbox" v-model="deshabilitados" />
          <span>
            Mostrar Circuitos
            <b>Deshabilitados</b>
          </span>
          <i class="mdi mdi-eye-off"></i>
        </label>

        <label class="list-group-item" :class="{ disabled: !deshabilitados }">
          <input type="checkbox" v-model="filtrar_deshabilitados" :disabled="!deshabilitados" />
          <span>
            Mostrar solo los Circuitos
            <b>Deshabilitados</b>
          </span>
          <i class="mdi mdi-eye-minus"></i>
        </label>

        <label class="list-group-item">
          <input type="checkbox" v-model="filtrar_destacados" />
          <span>
            Mostrar solo los Circuitos
            <b>Destacados</b>
          </span>

          <i class="mdi mdi-star"></i>
        </label>
      </div>
    </filtro>
    <placeholder v-else></placeholder>
  </div>
</template>

<style scoped>
.list-group {
  margin: 0;
  border-radius: 0;
  border: 0;
  min-height: 160px;
}
.list-group > .list-group-item {
  display: block;
  font-weight: normal;
  border-radius: 0;
  border-left: 0;
  border-right: 0;
  cursor: pointer;
  position: relative;
  padding: 10px 35px;
}

.list-group > .list-group-item:first-child {
  border-top: 0;
}
.list-group > .list-group-item:last-child {
  border-bottom: 0;
}
.list-group > .list-group-item:hover {
  background: #f4f5f7;
  color: #434a54;
}

.list-group > .list-group-item.disabled,
.list-group > .list-group-item.disabled:hover {
  color: #777;
  cursor: not-allowed;
  background-color: #eee;
}

.list-group > .list-group-item > input[type="checkbox"] {
  position: absolute;
  left: 15px;
  top: 15px;
  margin: 0;
  padding: 0;
}
.list-group > .list-group-item > .mdi {
  position: absolute;
  top: 50%;
  right: 10px;
  font-size: 23px;
  margin-top: -18px;
  color: #999;
}
</style>